<template>
  <section class="flex flex-col items-start justify-between">
    <div class="space-y-0.5">
      <div v-if="cashbackAmount > 0" class="flex gap-1">
        <span
          v-price="Number(offer.price.amount) - cashbackAmount"
          class="freedom-loyalty-text text-lg font-bold"
        ></span>
        <div class="flex items-center gap-2" @click.stop="onCashbackInfoClick">
          <span class="freedom-loyalty-text text-sm font-medium">{{
            t('search.cashback.withCashback')
          }}</span>
          <img
            src="@/assets/images/info-icon.svg"
            class="object-contain"
            height="14"
            width="14"
            alt=""
          />
        </div>
      </div>
      <i18n-t
        keypath="search.offerCard.priceToPay"
        tag="div"
        class="text-text-neutral-quaternary text-sm font-medium"
      >
        <template #price>
          <span
            v-price="offer.price.amount"
          ></span>
        </template>
        <template #oldPrice>
          <span
            v-if="offer.features?.discount?.initial_amount"
            v-price="offer.features?.discount?.initial_amount"
            class="text-xs font-normal line-through"
          ></span>
        </template>
      </i18n-t>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import {
    FlowType,
    freedomCashbackModel,
    type flightEntity,
  } from 'freedom-shared';

  import { api } from '@/shared/api';
  import { analyticsEventsLib } from '@/shared/lib';

  const props = defineProps<{
    offer: flightEntity.types.MappedOffer;
    offerIdx: number;
    offerPrice: string;
    source: string;
    cashbackClickSource: analyticsEventsLib.config.SearchResultCardCashbackPriceClickSource;
  }>();

  const emit = defineEmits<{ onCashbackInfoClick: [] }>();

  const { t } = useI18n();

  function onCashbackInfoClick() {
    analyticsEventsLib.searchResultCardCashbackPriceClick({
      app: FlowType.AVIA,
      source: props.cashbackClickSource,
    });
    emit('onCashbackInfoClick');
  }

  const { amount: cashbackAmount } = freedomCashbackModel.useFreedomCashback({
    pfm: api,
    offerPrice: props.offerPrice,
  });
</script>
